import moment from 'moment';
import memoize from 'memoize-one';

import {
  EMAIL_VALIDATION,
  PASSWORD_VALIDATION_LENGTH,
  PASSWORD_VALIDATION_NUMBER,
  PASSWORD_VALIDATION_UPPERCASE,
  PASSWORD_VALIDATION_LOWERCASE,
  FULL_NAME_VALIDATION,
  URL_VALIDATION,
  PASSWORD_CONFIRMATION,
  CARD_NAME_VALIDATION,
  PASSWORD_VALIDATION_SPACE,
  COUNTRY_VALIDATION,
} from './messages';
import {
  LOCAL_STORAGE_KEYS,
  errorMessages,
  regexps,
  TEXT_FIELD_STATUS,
  PARAMETERS,
  API_DEV,
  API_PROD,
  API_STAGE,
  getImageProd,
  getImageDev,
} from './constants';

export const emailValidator = (value) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const result = re.test(value) ? '' : EMAIL_VALIDATION;
  return result;
};
export const currencyValidator = (value) => {
  let result = '';
  if (parseFloat(value) === 0.0) result = 'Please enter non-zero value';
  return result;
};

export const userAmountValidator = (value) => {
  let result = '';

  if (parseFloat(value.replace(/\s/g, '')) < 200.0) result = 'Minimal amount is $200.00';
  return result;
};

export const fullNameValidation = (value) => {
  const test = value.trim().indexOf(' ') !== -1;
  // need clarification about full name validation
  const result = test ? '' : FULL_NAME_VALIDATION;
  return result;
};

export const cardNameValidation = (value) => {
  const test = /^[a-zA-Z() ]*$/.test(value);
  const result = test ? '' : CARD_NAME_VALIDATION;
  return result;
};

export const urlValidation = (value) => {
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}[.]{0,1}/;
  const result = re.test(value) ? '' : URL_VALIDATION;
  return result;
};

export const countryValidation = (value) => {
  const re = /[a-zA-Z]{2,}/;
  const result = re.test(value) ? '' : COUNTRY_VALIDATION;
  return result;
};
const pad = string => (`0${string}`).slice(-2);

export const formatDuration = (seconds) => {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
};

export const getSearch = () => document.location.search;

export const getHash = () => document.location.hash;

export const passwordValidator = (value) => {
  let result = '';
  const numbers = value.match(/\d+/g);
  const uppers = value.match(/[A-Z]/);
  const lowers = value.match(/[a-z]/);
  const space = value.match(/\s/);
  const length = value.length >= 6;
  if (!numbers) {
    result = PASSWORD_VALIDATION_NUMBER;
  }
  if (!uppers) {
    result = PASSWORD_VALIDATION_UPPERCASE;
  }
  if (!lowers) {
    result = PASSWORD_VALIDATION_LOWERCASE;
  }
  if (!length) {
    result = PASSWORD_VALIDATION_LENGTH;
  }
  if (space) {
    result = PASSWORD_VALIDATION_SPACE;
  }
  return result;
};

export const passwordConfirmation = (value1, value2) => {
  let result = '';
  if (value1 !== value2) result = PASSWORD_CONFIRMATION;
  return result;
};

export const setClientLastURL = (lastURL) => {
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.LAST_URL,
    lastURL,
  );
};

export const getClientLastURL = () => localStorage.getItem(LOCAL_STORAGE_KEYS.LAST_URL);

export const removeClientLastURL = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.LAST_URL);
};

export const setClientToken = (clientToken) => {
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.CLIENT_TOKEN,
    JSON.stringify(clientToken),
  );
};

export const getClientToken = () => {
  let result = localStorage.getItem(LOCAL_STORAGE_KEYS.CLIENT_TOKEN);
  if (result) {
    result = JSON.parse(result);
  }
  return result;
};

export const setUserToken = (userToken) => {
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.USER_TOKEN,
    JSON.stringify(userToken),
  );
};

export const getUserToken = () => {
  let result = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_TOKEN);
  if (result) {
    result = JSON.parse(result);
  }
  return result;
};

export const removeUserToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_TOKEN);
};

export const generatePassword = (length) => {
  let text = '';
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

export const serverErrorPrettier = (error) => {
  if (error) {
    const lowerError = error.toLowerCase();
    if (lowerError.indexOf('could not complete the registration') > -1) {
      return {
        header: 'Could not complete the registration.',
        description: 'If you already registered, please use the login form',
      };
    }
    if (lowerError.indexOf('bad credentials') > -1) {
      return errorMessages.badCredentials;
    }
    const userEmailMatch = lowerError.match(regexps.NO_USER_WITH_EMAIL);
    if (userEmailMatch && userEmailMatch.length === 2) {
      // const email = /email (.*) not/.exec(lowerError)[1];
      return {
        header: 'Could not complete the authorization',
        description: 'Please check password or Sign Up if you don\'t have account',
      };
    }
    if (lowerError.indexOf('user exists') > -1) {
      return {
        header: 'The user with this email is exists.',
        description: 'Please login, or use another email',
      };
    }
    if (lowerError.indexOf('the same password') > -1) {
      return {
        header: error,
        description: 'Please enter another password',
      };
    }
    if (
      lowerError.indexOf('reset password token not found or not valid') > -1
    ) {
      return {
        header: error,
        description: 'Please request token again',
      };
    }
    if (lowerError.indexOf('balance is too low to run this campaign') > -1) {
      return {
        header: error,
        description: 'Please refill your balance',
      };
    }
    if (lowerError.indexOf('disable app with active campaigns') > -1) {
      return {
        header: error,
        description: 'Deactivate all campaigns',
      };
    }
    if (lowerError.indexOf('wrong old password') > -1) {
      return {
        header: "You've entered wrong old password",
        description: 'If you forgot you password, try to restore it',
      };
    }
  }
  return { header: error, description: 'Please try again later!' };
};

export const currencyToCents = value =>
  Number(value.replace(/\s/g, '')) * 100;

export const getURLParameters = (url) => {
  const result = {};
  const searchIndex = url.indexOf('?');

  if (searchIndex === -1) return result;
  const sPageURL = url.substring(searchIndex + 1);
  const sURLVariables = sPageURL.split('&');
  for (let i = 0; i < sURLVariables.length; i += 1) {
    const sParameterName = sURLVariables[i].split('=');
    const key = sParameterName[0];
    const value = sParameterName[1];
    result[key] = value;
  }
  return result;
};

export const getHashURLParameters = (url) => {
  const result = {};
  const searchIndex = url.indexOf('#');

  if (searchIndex === -1) return result;
  const sPageURL = url.substring(searchIndex + 1);
  const sURLVariables = sPageURL.split('&');
  for (let i = 0; i < sURLVariables.length; i += 1) {
    const sParameterName = sURLVariables[i].split('=');
    const key = sParameterName[0];
    const value = sParameterName[1];
    result[key] = value;
  }
  return result;
};

export const serialize = (obj) => {
  const str = [];
  Object.keys(obj).forEach((p) => {
    if (obj[p]) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  });
  return str.join('&');
};
export const bytesToSize = (bytes) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (!bytes) {
    return '0 KB';
  }
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  return `${Math.round(bytes / (1024 ** i), 2)} (${sizes[i]})`;
};

export const getFieldCountryState = (
  value = '',
  needValidator = false,
) => ({
  value,
  needValidator,
});

export const getFieldInitialState = (
  status = TEXT_FIELD_STATUS.INITIAL,
  isFocused = false,
  value = '',
  platform = '',
  errorText = '',
  hint = '',
  needValidator = false,
) => ({
  status,
  isFocused,
  value,
  platform,
  errorText,
  hint,
  needValidator,
});

export const getFieldCreateAdminState = (
  status = TEXT_FIELD_STATUS.INITIAL,
  isFocused = false,
  value = '',
  errorText = '',
  hint = '',
  needValidator = false,
) => ({
  status,
  isFocused,
  value,
  errorText,
  hint,
  needValidator,
});

export const setCachedState = (componentName, value) => {
  localStorage.setItem(componentName, JSON.stringify(value));
};
export const getCachedState = (componentName) => {
  let result = localStorage.getItem(componentName);
  if (result) {
    result = JSON.parse(result);
  }
  return result;
};

export const formatNumber = (value, type, float = 2) => {
  if (!Number.isNaN(Number(value))) {
    if (
      type === PARAMETERS.CPI.value ||
      type === PARAMETERS.CPA.value ||
      type === PARAMETERS.SPENT.value
    ) {
      return Number((value / 100).toFixed(float));
    }
    if (type === PARAMETERS.CTR.value || type === PARAMETERS.CONVERSION.value) {
      return Number((value * 100).toFixed(float));
    }
  }
  return value;
};

export const formatNumberView = (value, type) => {
  if (value) {
    if (
      type === PARAMETERS.CPI.value ||
      type === PARAMETERS.CPA.value ||
      type === PARAMETERS.SPENT.value ||
      type === PARAMETERS.DAILY_BUDGET.value
    ) {
      return `${value} $`;
    }
    if (type === PARAMETERS.CTR.value || type === PARAMETERS.CONVERSION.value) {
      return `${value} %`;
    }
  }

  return value;
};

export const formatStringView = (value, type) => {
  if (value) {
    if (
      type === PARAMETERS.PLATFORM_ID.value
    ) {
      return `${value}`;
    }
  }

  return value;
};

export const filterTable = memoize((table, value) => {
  if (value) {
    return table.filter(tableRow => tableRow.id === value);
  }
  return table;
});

export const isActiveLink = (location, route) =>
  location.pathname.indexOf(route) > -1;

/* eslint-disable */
export const sumTable = (data, key) => {
  /* eslint-disable */
  return data.reduce((accum, value) => isNaN(value[key]) ? accum + 0 : accum + value[key], 0);
};

export const formatDate = date => moment(date).format('MMM, DD');

export const formatDateYear = date => moment(date).format('DD MMM YYYY');

export const formatRequestDate = date => moment(date).format('YYYY-MM-DD');

export const formatLogDate = date => moment(date).format('DD/MM/YYYY');

export const timeStampToDate = value => moment(value).format('MM/DD/YYYY');

export const capitalizeFirstLetter = string =>
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

export const getAPI = (publicHash) => {
  const { host, href } = window.location;
  if (host.indexOf('localhost') > -1) {
    return API_DEV;
  } else if (href.indexOf('dashboard.advaice.com') > -1) {
    return API_PROD;
  } else if (publicHash.indexOf('stage') > -1) {
    return API_STAGE;
  }
  return API_DEV;
};

export const getAppParserAPI = () => {
  const { href } = window.location;
  if (href.indexOf('dashboard.advaice.com') > -1) {
    return getImageProd;
  }
  return getImageDev;
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js